<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <business-item />
      </div>
    </div>
    <div class="row company-info">
      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <company-info />
      </div>
    </div>
  </div>
</template>
<script>
import BusinessItem from "../components/home/business.vue";
import CompanyInfo from "../components/home/companyInfo.vue";
export default {
  name: "Home",
  components: {
    BusinessItem,
    CompanyInfo,
  },
};
</script>
<style>
.company-info {
  background-color: #f6f6f6;
}
</style>


// WEBPACK FOOTER //
// src/pages/home.vue